<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
        </b-col>
        <b-col cols="12">

          <b-form @submit.prevent="updateData">
          <b-card no-body>
            <template v-slot:header>
              <span class="pull-left mt-2 mb-2">{{item.question}}</span>
            </template>
            <b-tabs pills card>
              <b-tab title="Details" active>
                <b-col cols="12" class="mt-2">

                  <b-form-group label="Vraag">
                    <b-form-input type="text" required v-model="item.question" :disabled="!editable"></b-form-input>
                  </b-form-group>

                  <b-form-group label="Antwoord">
                    <ckeditor
                      v-model="item.answer"
                      :disabled="!editable"
                      :editor="editor"
                      :config="editorConfig"/>

                  </b-form-group>
                </b-col>
              </b-tab>
            </b-tabs>

            <template v-slot:footer>
              <a class="btn btn-primary pull-left hoverable" @click="editable=true" v-if="!editable">Bewerken</a>
              <a class="btn btn-warning pull-left hoverable" @click="cancelEdit" v-if="editable">Annuleer</a>
              <b-button type="submit" variant="success" class="pull-right" v-if="editable">Opslaan</b-button>
            </template>
          </b-card>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import {getData, updateData} from '@/api';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ClassicEditor from '@/assets/ckeditor5';

export default {
  name: 'faq-single',

  components: { ClassicEditor },

  props: ['id'],

  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      contacts: [],
      editable: false,
      item: [],
      errors: null,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|',
            'bold', 'underline', 'italic', 'strikethrough', '|',
            'fontColor', 'fontBackgroundColor', '|',
            'indent', 'outdent', '|',
            'bulletedList', 'numberedList', '|',
            'link',
          ],

          height: '500px',
        },

        indentBlock: {
          offset: 1,
          unit: 'em'
        },

        fontColor: {
          colors: [
            {
              color: 'hsl(0, 0%, 0%)',
              label: 'Black'
            },
            {
              color: 'hsl(0, 0%, 52%)',
              label: 'Dim grey'
            },
            {
              color: 'hsl(19, 98%, 53%)',
              label: 'Orange'
            }
          ]
        }
      },
    }
  },

  methods: {
    async getItem() {
      const item = await getData('faq/' + this.$route.params.id).then(response => response.data);
      this.item = item.data
    },

    async updateData() {
      const request = await updateData('faq/' + this.$route.params.id, {
        question: this.item.question,
        answer: this.item.answer,
      }).then(response => response.data);
      this.item = request.data
      this.editable = false;
    },

    cancelEdit() {
      this.getItem();
      this.editable = false;
    },
  },

  beforeMount() {
    this.getItem();
  },
}

</script>
<style>
.ck-editor__editable {
  min-height: 300px;
}
</style>
